/*
Vacation card
*/

import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";

const VacationCard = ({ title, cardText, to, img }) => {
  return (
    <div className="vacationcard card-wrapper mb-4 mb-lg-0">
      <div
        className="card card-poster dark-overlay shadow-sm"
        style={{ alignItems: "center" }}
      >
        <Link to={to} className="tile-link"></Link>
        <div className="bg-image vacationcard-image-wrapper">
          <Img
            fluid={img.childImageSharp.fluid}
            alt=""
            className="vacationcard-image"
          />
        </div>
        <div className="card-body overlay-content text-center p-0">
          <span className="card-title text-shadow text-uppercase font-weight-bold">
            {title}
          </span>
          {/* <p className="card-text text-sm">{cardText}</p> */}
        </div>
      </div>
    </div>
  );
};
export default VacationCard;
